import { createFileRoute } from '@tanstack/react-router'

import { LeadsWorkspace } from '@/features/leads/leads-workspace'

export const Route = createFileRoute('/_app/leads/')({
  component: () => <LeadsWorkspace mode="list" />,
})
